<template>
  <AlbumForm    
    type="create"
  />
</template>

<script>
import AlbumForm from '@/components/form/AlbumForm'

export default {
  name: 'NewAlbum',
  components: {
    AlbumForm
  },
}
</script>
